import getConfig from 'next/config';
import React, { ReactNode } from 'react';
import { Dropdown } from 'react-bootstrap';

import { ExclamationIcon } from 'components/Icons';

import s from './PasswordExpiryDropdown.module.scss';

const {
  publicRuntimeConfig: { changePasswordUrl },
} = getConfig();

const CustomToggle = React.forwardRef<
  HTMLDivElement,
  { children: ReactNode; onClick: (e: React.MouseEvent) => void }
>(({ children, onClick }, ref) => (
  <div
    role="presentation"
    ref={ref}
    onClick={e => {
      e.preventDefault();
      onClick(e);
    }}
  >
    {children}
  </div>
));

CustomToggle.displayName = 'CustomToggle';

interface IProps {
  children: ReactNode;
}

const PasswordExpiryDropdown: React.FC<IProps> = ({ children }) => (
  <Dropdown className={s.root}>
    <Dropdown.Toggle as={CustomToggle} id="dropdown-user">
      <ExclamationIcon size={3} fill="#FFFFFF" />
    </Dropdown.Toggle>

    <Dropdown.Menu className={s.dropdownMenu}>
      <Dropdown.ItemText className={s.item}>
        <div className="d-flex justify-space-between">
          <ExclamationIcon size={2} fill="#EAAA00" />

          <div className="ml-3">
            {children}

            <a
              href={changePasswordUrl}
              target="_blank"
              rel="noreferrer"
              className="btn btn-primary"
            >
              Change password
            </a>
          </div>
        </div>
      </Dropdown.ItemText>
    </Dropdown.Menu>
  </Dropdown>
);

export default PasswordExpiryDropdown;
